/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoSysMaintenanceInfoRequest model module.
 * @module model/SystemControllerDtoSysMaintenanceInfoRequest
 * @version 1.0
 */
class SystemControllerDtoSysMaintenanceInfoRequest {
    /**
     * Constructs a new <code>SystemControllerDtoSysMaintenanceInfoRequest</code>.
     * @alias module:model/SystemControllerDtoSysMaintenanceInfoRequest
     * @param maintenanceNo {Number} 
     */
    constructor(maintenanceNo) { 
        
        SystemControllerDtoSysMaintenanceInfoRequest.initialize(this, maintenanceNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, maintenanceNo) { 
        obj['maintenanceNo'] = maintenanceNo;
    }

    /**
     * Constructs a <code>SystemControllerDtoSysMaintenanceInfoRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoSysMaintenanceInfoRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoSysMaintenanceInfoRequest} The populated <code>SystemControllerDtoSysMaintenanceInfoRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoSysMaintenanceInfoRequest();

            if (data.hasOwnProperty('maintenanceNo')) {
                obj['maintenanceNo'] = ApiClient.convertToType(data['maintenanceNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoSysMaintenanceInfoRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoSysMaintenanceInfoRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoSysMaintenanceInfoRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

SystemControllerDtoSysMaintenanceInfoRequest.RequiredProperties = ["maintenanceNo"];

/**
 * @member {Number} maintenanceNo
 */
SystemControllerDtoSysMaintenanceInfoRequest.prototype['maintenanceNo'] = undefined;






export default SystemControllerDtoSysMaintenanceInfoRequest;

